<template>
    <el-drawer
        :title="`${item.id?'编辑':'新增'}活动`"
        :visible.sync="show"
        :wrapperClosable="false"
        direction="rtl"
        size="1000px"
        :before-close="close">
        <div class="panel fx-g1">
            <el-tabs  class="fx-g1 fx-col inner_tags-page">
                <!--<el-tab-pane label="活动" name="saveSubject"> -->
                    <el-form ref="form" :model="form" label-width="150px" class="edit_form">
                        <el-form-item label="封面">
                            <el-upload
                                class="photo_uploader"
                                action=""
                                :show-file-list="false"
                                :before-upload="uploadBackgroundImg">
                                <img v-if="form.coverImg != null" :src="form.coverImg" class="avatar">
                                <i v-else class="el-icon-plus uploader-icon"></i>
                            </el-upload>
                            <!--<el-button type="primary" size="small" @click="showBanner()">从总部图库添加</el-button>-->
                        </el-form-item>
                        <el-form-item label="标题" v-check="{'必填': !form.title}">
                            <el-input v-model="form.title"></el-input>
                        </el-form-item>
                        <el-form-item label="简介" v-check="{'必填': !form.content}">
                            <el-input type="textarea" v-model="form.content"></el-input>
                        </el-form-item>
                        <el-form-item label="详情">
                            <div class="panel fx-g1">
                                <vue-neditor-wrap v-model="form.details" :config="myConfig" :destroy="false" ></vue-neditor-wrap>
                            </div>
                        </el-form-item>
                        <el-form-item label="活动时间" v-check="{'必填': !form.datesVelue}">
                            <el-date-picker
                                v-model="form.datesVelue"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="报名时间" v-check="{'必填': !datesVelue1}">
                            <el-date-picker
                                v-model="datesVelue1"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                            </el-date-picker>
                        </el-form-item>
                    </el-form>
                <!-- </el-tab-pane> -->
                <!-- <el-tab-pane label="总部图库" name="addBanner" v-if="bannerShow">
                    <el-table
                        ref="bannerTable"
                        :data="bannerLib"
                        style="width: 100%;overflow: auto;"
                    >
                        <el-table-column
                            type="radio"
                            width="55">
                             <template slot-scope="scope">
                                <el-radio v-model="radio" :label="scope.row.id" @change="handlePicChoose(scope.row)">{{''}}</el-radio>
                             </template>
                        </el-table-column>
                        <el-table-column
                            min-width="460px"
                            label="" >
                            <template slot-scope="scope">
                                <img :src="scope.row.value" style="width: 500px; height: 220px">
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane> -->

            </el-tabs>

        </div>
        <span  class="fx fx-center">
            <el-button type="primary" @click="sub()">确 定</el-button>
            <el-button @click="close()">关 闭</el-button>
        </span>
    </el-drawer>
</template>

<style scoped>
    .edit_form {
        margin-top: 20px;
        width: 88%;
    }
    .el-radio__label {
        display: none;
    }
</style>
<script>
    import VueNeditorWrap from 'vue-neditor-wrap'
    export default {
        props: [
            "item",
        ],
        components: {
            VueNeditorWrap
        },
        data() {
            return {
                show: true,
                form: {...this.item},
                commLessonTypes:[],
                datesVelue:[],
                datesVelue1:[],
                //activeTab: 'saveSubject',
                bannerLib:[],
                radio: '',
                bannerShow:false,
                myConfig: {
                    // 如果需要上传功能,找后端小伙伴要服务器接口地址
                    serverUrl: '/api/web/upload/ueditor',
                    UEDITOR_HOME_URL: '/admin/NEditor/',
                    // 编辑器不自动被内容撑高
                    autoHeightEnabled: false,
                    // 初始容器高度
                    initialFrameHeight: 400,
                    // 初始容器宽度
                    initialFrameWidth: '100%',
                    // 关闭自动保存
                    enableAutoSave: true,
                    maximumWords:2000
                },
            }
        },
        methods: {
            close() {
                this.$emit("close");
            },
            sub() {
                this.$checkForm(this.$refs.form).then(success => {
                    if (success) {
                        //校验通过，干什么....
                        if(this.form.datesVelue.length == 0){
                            this.$showError("请选择活动时间");
                            return;
                        }
                        if(this.datesVelue1.length == 0){
                            this.$showError("请选择报名时间");
                            return;
                        }
                        this.form.startTime = this.form.datesVelue != null ? this.form.datesVelue[0] : "";
                        this.form.endTime =  this.form.datesVelue != null ? this.form.datesVelue[1] : "";
                        this.form.signUpStartTime = this.datesVelue1 != null ? this.datesVelue1[0] : "";
                        this.form.signUpEndTime =  this.datesVelue1 != null ? this.datesVelue1[1] : "";
                        let data = {...this.form};
                        this.$ajaxPost("/activity/save", {
                            activity: data
                        }, (data) => {
                            this.$showSuccess("保存成功");
                            this.$emit("submit", data.result);
                        })
                        return false;
                    } else {
                        this.$showError("请输入内容再保存");
                    }
                })
            },
            //showBanner() {
                //this.bannerShow = true;
                //this.activeTab = 'addBanner';
            //},
            handlePicChoose(item) {
                this.form.coverImg = item.value;
            },
            uploadBackgroundImg(file) {
                this.$uploadQiniu(file, "activity/", {
                        success: (file) => {
                            this.form = Object.assign({}, this.form, {coverImg: file.url});
                        }
                    }
                )
                return false;
            },
            loadBannerData() {
                //加载总部图库
                this.$ajaxGet("/dictionary/listCenterBannerLib/4", data => {
                    this.bannerLib = data.result;
                })
            }
        },
        mounted() {
            this.show = true;
        },
        created() {
            if(this.item.id > 0){
                this.form.datesVelue[0] = this.item.startTime;
                this.form.datesVelue[1] = this.item.endTime;
                this.datesVelue1[0] = this.form.signUpStartTime;
                this.datesVelue1[1] =  this.form.signUpEndTime;
            }
            if(this.form.id == undefined){//新增 内容清空
                this.form.details = "";
            }
            //this.loadBannerData();
        }


    }
</script>
